import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';

import MenuIcon from '@mui/icons-material/Menu';
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Stack,
  ListItem,
  Button,
} from '@mui/material';
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// import { PromoCard } from '../promo-card';
import { NavItem } from './nav-item';
import { LogoIcon } from 'assets/icons';
import { NavEntity } from 'types/header';

export const MobileNavigation = ({
  items,
  color = 'text.primary',
}: // isAuthenticated = false,
{
  items: NavEntity[];
  color?: string;
  // isAuthenticated?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const [expandedItem, setExpandedItem] = useState<string | null>(null);

  const handleDrawerToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleItemClick = (id: string) => {
    setExpandedItem(expandedItem === id ? null : id);
  };

  const currentItem = items.find(item => item.id === expandedItem);

  return (
    <>
      <IconButton
        title="Menu FLA"
        onClick={handleDrawerToggle}
        sx={{
          color,
          marginLeft: '-8px',
        }}
        aria-label="open menu"
      >
        <MenuIcon />
      </IconButton>

      <Drawer
        anchor="left"
        open={open}
        onClose={handleDrawerToggle}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            bgcolor: 'white', // 'background.default',
          },
        }}
      >
        <Box
          sx={{
            p: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            bgcolor: 'white',
            gap: 2,
          }}
        >
          <IconButton onClick={handleDrawerToggle} aria-label="close menu">
            <CloseIcon />
          </IconButton>
          <RouterLink
            to="/"
            style={{ display: 'flex', flex: 1 }}
            aria-label="Home"
          >
            <LogoIcon />
          </RouterLink>
          {/* {isAuthenticated && (
            <Button variant="contained" href="/logout">
              <LogoutIcon />
            </Button>
          )} */}
        </Box>
        <Stack
          direction={'row'}
          sx={{ backgroundColor: 'white', px: 2, py: 4, flex: 1 }}
        >
          {!expandedItem ? (
            <Stack
              direction={'column'}
              width={'100%'}
              justifyContent={'space-between'}
            >
              <List sx={{ width: '100%' }}>
                {items.map(item => (
                  <ListItem key={item.title} disablePadding>
                    {item.hasDropdown ? (
                      <ListItemButton
                        disableRipple
                        disableTouchRipple
                        disableGutters
                        disabled={item.disabled}
                        onClick={() => handleItemClick(item.id)}
                        sx={{
                          py: 2,
                          gap: 1,
                        }}
                      >
                        <Stack direction={'row'} gap={1} alignItems={'center'}>
                          <ListItemText
                            primary={item.title}
                            primaryTypographyProps={{
                              variant: 'body1',
                              // variant: 'headline3',
                              sx: { letterSpacing: '-3%' },
                            }}
                          />
                          <ListItemIcon sx={{ minWidth: 'auto' }}>
                            <ChevronRightIcon />
                          </ListItemIcon>
                        </Stack>
                      </ListItemButton>
                    ) : (
                      <ListItemButton
                        disableRipple
                        disableTouchRipple
                        disableGutters
                        disabled={item.disabled}
                        component={RouterLink}
                        to={item.path}
                        onClick={() => handleDrawerToggle()}
                        sx={{
                          py: 2,
                        }}
                      >
                        <ListItemText
                          primary={item.title}
                          primaryTypographyProps={{
                            variant: 'body1',
                            // variant: 'headline3',
                          }}
                        />
                      </ListItemButton>
                    )}
                  </ListItem>
                ))}
              </List>
              {/* <PromoCard
                cardEvent={{
                  title: 'Promo Card',
                  path: '/',
                  description: 'Promo Card',
                }}
                sx={{ height: 200 }}
              /> */}
            </Stack>
          ) : currentItem ? (
            <NavItem
              item={currentItem}
              onClickBack={() => setExpandedItem(null)}
              closeMenu={() => setOpen(false)}
            />
          ) : null}
        </Stack>
        <Stack sx={{ px: 2, pb: 4, maxWidth: '220px' }} gap={2}>
          <Button
            href="/associati-federlegnoarredo"
            // withStandardIcon
          >
            Diventa un associato
          </Button>
        </Stack>
      </Drawer>
    </>
  );
};
